import {
  REQUEST_SAVE_UNIT_REPORT,
  RESPONSE_SAVE_UNIT_REPORT,
  REQUEST_SAVE_UNIT_REPORT_FAILURE,
  CLEAR_SAVE_UNIT_REPORT
} from './../actions/saveUnitReportActions'

import { states } from './queriesStates'

const initialState = {
  dataState: states.NOT_REQUESTED,
  errors: [],
}

const saveUnitReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_SAVE_UNIT_REPORT:
      return Object.assign(
        {},
        state,
        {
          dataState: states.REQUEST
        }
      )
    case RESPONSE_SAVE_UNIT_REPORT:
      return Object.assign(
        {},
        state,
        {
          dataState: states.READY
        }
      )
    case REQUEST_SAVE_UNIT_REPORT_FAILURE:
      return Object.assign(
        {},
        state,
        {
          dataState: states.FAILURE,
          errors: action.errors
        }
      )
    case CLEAR_SAVE_UNIT_REPORT:
      return Object.assign(
        {},
        state,
        initialState
      )
    default:
      return state
  }
}

export default saveUnitReportReducer